import { ActivateController } from './activate.controller';

export const ActivateComponent: ng.IComponentOptions = {
    template: require('./activate.html'),
    controller: ActivateController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/registration/activate/activate.component.ts